import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function StickyOfferBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight;
      setIsVisible(window.scrollY > heroHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-274">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed top-0 left-0 right-0 z-50" data-id="element-275">
          <div className="border-b border-[#C9A84C]/40" style={{
        background: 'linear-gradient(0deg, rgba(10,10,10,0.95) 0%, rgba(15,12,8,0.98) 100%)',
        backdropFilter: 'blur(20px)'
      }} data-id="element-276">
            <div className="max-w-5xl mx-auto flex items-center justify-between px-3 py-1.5 md:py-2 gap-2" data-id="element-277">
              {/* Logo */}
              <img src="https://cdn.magicpatterns.com/uploads/oVduJGmSayLGnWM11iC4cN/Logo_Renova.png" alt="Renova Detail" className="h-6 md:h-8 object-contain flex-shrink-0" data-id="element-278" />

              {/* CTA Button */}
              <motion.button onClick={handleClick} animate={{
            boxShadow: ['0 0 15px rgba(212,160,23,0.3), 0 0 30px rgba(212,160,23,0.1)', '0 0 25px rgba(212,160,23,0.5), 0 0 50px rgba(212,160,23,0.2)', '0 0 15px rgba(212,160,23,0.3), 0 0 30px rgba(212,160,23,0.1)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="relative overflow-hidden flex items-center gap-1.5 px-4 md:px-6 py-1.5 md:py-2 rounded-full font-black text-xs md:text-sm uppercase tracking-wider text-black cursor-pointer border border-[#C9A84C]/50" style={{
            background: 'linear-gradient(135deg, #F5C518 0%, #FFD700 30%, #E8B830 60%, #F5C518 100%)'
          }} data-id="element-279">
                <span className="relative z-10 whitespace-nowrap" data-id="element-280">
                  VER OFERTA
                </span>
                <motion.div animate={{
              x: [0, 4, 0]
            }} transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative z-10" data-id="element-281">
                  <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-282" />
                </motion.div>
                {/* Shine effect */}
                <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-30 animate-shine" data-id="element-283" />
              </motion.button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}